import * as i0 from '@angular/core';
import { Injectable, Inject, Optional } from '@angular/core';
import { createDynatraceWebService } from '@dch/monitoring';

class PxDynatraceService {
    constructor(applicationName) {
        this.applicationName = applicationName;
        this.dynatraceLogger = createDynatraceWebService(this.applicationName);
    }
    get enabled() {
        return !!this.applicationName;
    }
    identifyUser(name) {
        !!this.applicationName && this.dynatraceLogger.identifyUser(name);
    }
    logInfo(name, description) {
        !!this.applicationName && this.dynatraceLogger.logInfo(name, description);
    }
    logError(name, errorDescripton) {
        !!this.applicationName && this.dynatraceLogger.logError(name, errorDescripton);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.1", ngImport: i0, type: PxDynatraceService, deps: [{ token: 'pxDynatraceApplicationName', optional: true }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.1", ngImport: i0, type: PxDynatraceService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.1", ngImport: i0, type: PxDynatraceService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: ['pxDynatraceApplicationName']
                }, {
                    type: Optional
                }] }] });

/**
 * Generated bundle index. Do not edit.
 */

export { PxDynatraceService };
